import Http from '../../../http';

// eslint-disable-next-line
export const saveCommissionTier = (shopId, data) => dispatch =>
  Http.post(`/shop/${shopId}/commission-tier`, data);

export const fetchCommissionTiers = shopId => () => (
  Http.get(`/shop/${shopId}/commission-tier`)
);
